import React, { useContext } from 'react';
import { CameraList, AddCamera, EditCamera } from "./";
import { CameraSection } from "../../context/CameraContext";

const CameraComp = () => {
    const { cameraPage } = useContext(CameraSection);

    return (
        <div style={{ minHeight: '90vh' }}>
            {cameraPage.firstPage && <CameraList />}
            {cameraPage.addCamera && <AddCamera />}
            {cameraPage.editCamera && <EditCamera />}
        </div>
    );
};

export { CameraComp };